var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 9.33464H25.3333C26.1333 9.33464 26.6667 8.8013 26.6667 8.0013C26.6667 7.2013 26.1333 6.66797 25.3333 6.66797H6.66666C5.86666 6.66797 5.33333 7.2013 5.33333 8.0013C5.33333 8.8013 5.86666 9.33464 6.66666 9.33464ZM6.66666 17.3346H25.3333C26.1333 17.3346 26.6667 16.8013 26.6667 16.0013C26.6667 15.2013 26.1333 14.668 25.3333 14.668H6.66666C5.86666 14.668 5.33333 15.2013 5.33333 16.0013C5.33333 16.8013 5.86666 17.3346 6.66666 17.3346ZM6.66666 25.3346H25.3333C26.1333 25.3346 26.6667 24.8013 26.6667 24.0013C26.6667 23.2013 26.1333 22.668 25.3333 22.668H6.66666C5.86666 22.668 5.33333 23.2013 5.33333 24.0013C5.33333 24.8013 5.86666 25.3346 6.66666 25.3346Z",
    fill: "url(#paint0_linear_8633_15191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8633_15191",
    x1: 26.6646,
    y1: 15.9132,
    x2: 4.2256,
    y2: 15.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c4fff47d3e185c7c9c79e1db33cf7249.svg";
export { ForwardRef as ReactComponent };